// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { getEnvBotName, parsePolarisEnv } from '@polarissleep/shared';
import { BOTS_SYSTEM } from './constants';

function resolveEnv(): string {
  const raw = import.meta.env?.VITE_POLARIS_ENV;
  return parsePolarisEnv(raw);
}

/**
 * Builds the `{ system, value }` identifier used to execute a bot, automatically
 * prefixing the bot name with the current Polaris environment. Call sites use
 * this helper instead of hardcoding `{ system: BOTS_SYSTEM, value: 'foo' }`
 * so that each environment calls its own deployed bots.
 */
export function botIdentifier(botName: string): { system: string; value: string } {
  return { system: BOTS_SYSTEM, value: getEnvBotName(resolveEnv(), botName) };
}
